module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_five-bdd26d4dd69973e457300bcbf214e400.jpg";